import { Component, Input }        from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { Table } from '../table/types/table';

@Component({
  selector   : 'wor-product-branch-stock',
  template: require('./product.branch-stock.component.html')
})
export class ProductBranchStockComponent {
  public tableSettings : Table = {
    columns: [
      {
        field : 'store_name',
        header: {
          text: 'Store Name'
        }
      },
      {
        classes: 'all-caps',
        field  : 'item_code',
        header : {
          text: this.translateService.instant('PRODUCT_SPACE.ITEM_CODE')
        }
      },
      {
        classes: 'text-right',
        field  : 'quantity_on_hand',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('PRODUCT_SPACE.QTY')
        }
      },
      {
        classes: 'text-right',
        field  : 'qty_reserved',
        header : {
          classes: 'text-right',
          text   : 'Qty Reserved'
        }
      }
    ],
    empty: {
      text: this.translateService.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
    },
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  @Input() products : Array<any> = [];

  constructor (
    public activeModal      : NgbActiveModal,
    private translateService: TranslateService
  ) {}
}